export const MediaQueries = {
  largeDesktopAndUp: "(min-width:1200px)",
  desktopAndUp: "(min-width:992px)",
  tabletAndUp: "(min-width:768px)",
  landscapePhoneAndUp: "(min-width:522px)",
  isXXS: "(max-width:521px)",
  isXS: "(max-width:767px)",
  isTouchscreen: "(max-width:991px)",
  md: "1200px",
  sm: "992px",
  xs: "768px",
  xxs: "522px",
};
